/**
 * Minified by jsDelivr using UglifyJS v3.1.10.
 * Original file: /npm/iso8601-js-period@0.2.1/iso8601.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!(function (e, r) {
  "function" == typeof define && define.amd
    ? define([], r)
    : "object" == typeof module && module.exports
    ? (module.exports = r())
    : (e.nezasa || (e.nezasa = {}),
      e.nezasa.iso8601 || (e.nezasa.iso8601 = r()));
})(this, function () {
  function e(e, r) {
    var n,
      o = r || !1,
      t = [2, 3, 4, 5, 7, 8, 9],
      i = [0, 0, 0, 0, 0, 0, 0],
      a = [0, 12, 4, 7, 24, 60, 60];
    if (!(e = e.toUpperCase())) return i;
    if ("string" != typeof e)
      throw new Error("Invalid iso8601 period string '" + e + "'");
    if (
      !(n = /^P((\d+Y)?(\d+M)?(\d+W)?(\d+D)?)?(T(\d+H)?(\d+M)?(\d+S)?)?$/.exec(
        e
      ))
    )
      throw new Error("String '" + e + "' is not a valid ISO8601 period.");
    for (s = 0; s < t.length; s++) {
      var d = t[s];
      i[s] = n[d] ? +n[d].replace(/[A-Za-z]+/g, "") : 0;
    }
    if (o)
      for (var s = i.length - 1; s > 0; s--)
        i[s] >= a[s] &&
          ((i[s - 1] = i[s - 1] + Math.floor(i[s] / a[s])),
          (i[s] = i[s] % a[s]));
    return i;
  }
  var r = { Period: {} };
  return (
    (r.version = "0.2"),
    (r.Period.parse = function (r, n) {
      return e(r, n);
    }),
    (r.Period.parseToTotalSeconds = function (r) {
      for (
        var n = [31104e3, 2592e3, 604800, 86400, 3600, 60, 1],
          o = e(r),
          t = 0,
          i = 0;
        i < o.length;
        i++
      )
        t += o[i] * n[i];
      return t;
    }),
    (r.Period.isValid = function (r) {
      try {
        return e(r), !0;
      } catch (e) {
        return !1;
      }
    }),
    (r.Period.parseToString = function (r, n, o, t) {
      var i = ["", "", "", "", "", "", ""],
        a = e(r, t);
      n || (n = ["year", "month", "week", "day", "hour", "minute", "second"]),
        o ||
          (o = [
            "years",
            "months",
            "weeks",
            "days",
            "hours",
            "minutes",
            "seconds",
          ]);
      for (var d = 0; d < a.length; d++)
        a[d] > 0 &&
          (1 == a[d] ? (i[d] = a[d] + " " + n[d]) : (i[d] = a[d] + " " + o[d]));
      return i
        .join(" ")
        .trim()
        .replace(/[ ]{2,}/g, " ");
    }),
    r
  );
});
//# sourceMappingURL=/sm/655fa2fb045e3d642a59ec20b0d23af6fcd4915b4f2ec42bee30cdcee361f8bc.map
